import { localeRequestHeaders } from './localePreference';
import { apiErrorMessage } from './apiErrorMessages';

const API_PREFIX = '/api/v1';

async function postOnboarding(path, user, body) {
  const token = await user.getIdToken();
  let response;

  try {
    response = await fetch(`${API_PREFIX}/onboarding${path}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...localeRequestHeaders(),
      },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error(apiErrorMessage('onboardingNetwork'));
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const requestError = new Error(error.detail || apiErrorMessage('onboardingRequest'));
    requestError.status = response.status;
    throw requestError;
  }

  return response.json();
}

export async function startOnboardingConversation({ user, firstName, cvStoragePath, cvFileName }) {
  return postOnboarding('/start', user, {
    firstName,
    cvStoragePath,
    cvFileName,
  });
}

export async function getNextOnboardingTurn({ user, conversation, question, answer }) {
  return postOnboarding('/turn', user, {
    conversation,
    question,
    answer,
  });
}

export async function extractScoutFromCv({ user, firstName, cvStoragePath, cvFileName }) {
  return postOnboarding('/extract', user, {
    firstName,
    cvStoragePath,
    cvFileName,
  });
}

export async function submitOnboardingCompletion({
  user,
  completionId,
  conversation,
  question,
  answer,
}) {
  return postOnboarding('/complete', user, {
    completionId,
    conversation,
    question,
    answer,
  });
}
